import { render } from "./ProductReviewAuthor.vue?vue&type=template&id=a1bdca8a&scoped=true"
import script from "./ProductReviewAuthor.vue?vue&type=script&lang=js"
export * from "./ProductReviewAuthor.vue?vue&type=script&lang=js"

import "./ProductReviewAuthor.vue?vue&type=style&index=0&id=a1bdca8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1bdca8a"]])

export default __exports__